import { Routes } from '@angular/router';
import { authGuard } from '@app/auth/auth.guard';
import { mobileOnlyGuard } from '@app/mobile-only.guard';
import { Users } from '@app/users/users';
import { Tickets } from '@app/tickets/tickets';
import { Login } from '@app/auth/login/login';
import { Dashboard } from '@app/dashboard/dashboard';
import { Settings } from '@app/settings/settings';

export const routes: Routes = [
  // Public (guard can redirect logged-in users away)
  { path: '', component: Login, canActivate: [authGuard], data: { title: 'Login' } },
  { path: 'login', component: Login, canActivate: [authGuard], data: { title: 'Login' } },
  // Protected (everything here requires auth)
  {
    path: '',
    canActivate: [authGuard],
    children: [
      { path: 'dashboard', component: Dashboard, data: { title: 'Dashboard' } },
      { path: 'users', component: Users, data: { title: 'Users' } },
      { path: 'tickets', component: Tickets, data: { title: 'Tickets' } },
      { path: 'settings', component: Settings, data: { title: 'Settings' } }
    ],
  },

  // Optional: fallback
  { path: '**', redirectTo: '' },
];